import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ChatSession, ChatMessage, ChatState } from './chatTypes';

const initialState: ChatState = {
  sessions: {},
  activeSessionId: null,
  messages: {},
  loading: false,
  error: null,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setActiveSession: (state, action: PayloadAction<string>) => {
      state.activeSessionId = action.payload;
    },
    
    addSession: (state, action: PayloadAction<ChatSession>) => {
      state.sessions[action.payload.session_id] = action.payload;
    },
    
    addMessage: (
      state,
      action: PayloadAction<{ sessionId: string; message: ChatMessage }>
    ) => {
      const { sessionId, message } = action.payload;
      if (!state.messages[sessionId]) {
        state.messages[sessionId] = [];
      }
      state.messages[sessionId].push(message);
    },
    
    clearMessages: (state, action: PayloadAction<string>) => {
      delete state.messages[action.payload];
    },
    
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setActiveSession,
  addSession,
  addMessage,
  clearMessages,
  setLoading,
  setError,
} = chatSlice.actions;

export default chatSlice.reducer;
